import Spacings from "../../../../../../packages/design-system/src/Spacings";
import Text from "../../../../../../packages/design-system/src/Text";
import BoxedCollapsible from "../../../../../../packages/design-system/src/BoxedCollapsible";
import * as React from 'react';
export default {
  Spacings,
  Text,
  BoxedCollapsible,
  React
};